import { Breakpoint } from 'shared/types/Breakpoint'
import { BreakpointConfig } from 'shared/types/BreakpointConfig'
import { BreakpointWidthState } from 'shared/types/BreakpointWidthState'
import { DEFAULT_BREAKPOINTS } from 'shared/constants/breakpointsWidth'

export const debounce = <T extends (...args: any[]) => any>(
    func: T,
    delay: number
): ((...args: Parameters<T>) => void) => {
    let timeoutId: NodeJS.Timeout;

    return (...args: Parameters<T>) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(null, args), delay);
    };
};

export const getBreakpoint = (
    width: number,
    breakpoints: BreakpointConfig = DEFAULT_BREAKPOINTS
): Breakpoint => {
    if (width >= breakpoints.xxl) return 'xxl';
    if (width >= breakpoints.xl) return 'xl';
    if (width >= breakpoints.lg) return 'lg';
    if (width >= breakpoints.md) return 'md';
    if (width >= breakpoints.sm) return 'sm';
    return 'xs';
};

export const isMobile = (breakpoint: Breakpoint): boolean => {
    return breakpoint === 'xs' || breakpoint === 'sm';
};

export const isTablet = (breakpoint: Breakpoint): boolean => {
    return breakpoint === 'md';
};

export const isDesktop = (breakpoint: Breakpoint): boolean => {
    return breakpoint === 'lg' || breakpoint === 'xl' || breakpoint === 'xxl';
};

export const getOrientation = (width: number, height: number): 'portrait' | 'landscape' => {
    return width > height ? 'landscape' : 'portrait';
};

export const mergeBreakpoints = (
    customBreakpoints?: Partial<BreakpointConfig>
): BreakpointConfig => {
    return {
        ...DEFAULT_BREAKPOINTS,
        ...customBreakpoints,
    };
};